var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.32 14.52L39.5 11.7L32.38 18.8L35.2 21.62C35.2 21.62 42.1 14.58 42.32 14.52ZM22 6H26V16H22V6ZM12.8 21.62L15.62 18.8L8.52 11.68L5.68 14.52C5.9 14.58 12.8 21.62 12.8 21.62ZM40 24H30C30 27.32 27.32 30 24 30C20.68 30 18 27.32 18 24H8C5.8 24 4 25.8 4 28V38C4 40.2 5.8 42 8 42H40C42.2 42 44 40.2 44 38V28C44 25.8 42.2 24 40 24Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon2);
export default __webpack_public_path__ + "static/media/cardIcon2.679161fe0041e7c95e4ad809d27c25fc.svg";
export { ForwardRef as ReactComponent };